var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note px-4 pt-4 pb-2"},[_c('p',{staticClass:"note__body pb-2"},[_vm._v(_vm._s(_vm.list))])])}
var staticRenderFns = []

export { render, staticRenderFns }